<template>
  <div class="pop" v-show="popModal" v-clickoutside="hide">
    <div class="pop_top">
      <div class="message_icon_box">
        <el-image class="customer_icon" src="/static/xiaocai.png"></el-image>
        <p>{{$ts('智能小菜提醒')}}</p>
      </div>

      <div class="close" @click="closeTab"><i class="el-icon-error"></i></div>
    </div>
    <div class="pop_content" id="pop_content" @scroll="scrolltolower">
      <div id="pop_content_li">
        <div class="pop_content_li" v-for="(item,index) in messList" :key="index" @click="tolist(item)">
          <div>{{item.create_time_str}}</div>
          <div class="li_title" :class="item.level">{{item.title}}</div>
          <div class="li_content">
            <div class="li_tip" v-for="(ite,key) in item.tip_arr" :key="key">
              <span v-if="ite.label">{{ite.label}}: </span>
              <span v-html="ite.value"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="pop_more" id="pop_more" @click="getLower">
        {{more=='noMore'?$ts('没有更多了'):more=='loading'?$ts('加载中'):$ts('点击加载')}}
      </div>
    </div>
  </div>
</template>

<script>
  import {
    debounceFn
  } from '@/assets/js/tool.js';
  import clickoutside from 'element-ui/src/utils/clickoutside'
  export default {
    directives: {
      clickoutside
    },
    data() {
      return {
        popModal: false,
        page: 1,
        limit: 10,
        more: 'more', //
        messList: [],
        popTime: 0
      }
    },
    mounted() {

    },
    methods: {
      toggle(show) {
        if (show !== undefined) {
          this.popModal = show;
        } else {
          this.popModal = !this.popModal;
        }
        if (this.popModal) {
          clearTimeout(this.popTime)
          this.popTime = setTimeout(() => {
            this.popModal = false;
          }, 10000)
        }
        if (this.popModal && this.messList.length == 0 && this.more == 'more') {
          this.init()
        }
      },
      hide() {
        if (this.popModal) {
          this.popModal = false;
          clearTimeout(this.popTime)
        }
      },
      init() {
        this.page = 1;
        this.more = 'more';
        this.messList = [];
        this.getList(1)
      },
      scrolltolower: debounceFn(function(e) {
        let listH = document.getElementById('pop_content_li').clientHeight;
        let scrollTop = e.target.scrollTop;
        let contentH = e.target.clientHeight;
        if (listH - contentH - scrollTop < 30) {
          this.getLower()
        }
      }),
      getLower() {
        if (this.more != 'more') {
          return
        }
        this.page++;
        this.getList(this.page)
      },
      getList(page) {
        if (this.more != 'more') {
          return
        }
        this.more = 'loading';
        let params = {
          page: page,
          page_num: this.limit,
        }
        this.request({
          url: '/admin/notice/notice_list',
          data: params,
          is_public: true,
          complete: (res) => {
            if (res.error_code == 0) {
              if (this.page == page) {
                let list = res.data.data;
                list.forEach(item => {
                  this.initTypeData(item)
                })
                this.messList = this.messList.concat(list)
                if (list.length < this.limit) {
                  this.more = 'noMore'
                } else {
                  this.more = 'more';
                }
              }
            } else {
              this.more = 'noMore';
            }
          }
        })
      },
      tolist(item) {
        this.popshow = false;
        switch (item.relation_type) {
          case 'order':
            this.navTo('/comprehensive-order', {
              order_no: item.content.order_no
            })
            break;
          case 'delivery_back':
            this.navTo('/deliveryback')
            break;
          case 'goods_apply':
            this.navTo('/comprehensive-goods?type=4')
            break;
          case 'alert':
            this.navTo('/comprehensive-unusual')
            break;
          case 'subcontract':
            this.navTo('/subcontract')
            break;
          case 'sort':
            this.navTo('/sortingtask', {
              no: item.content.order_no
            })
            break;
        }
      },
      closeTab() {
        this.popModal = false;
      },
      initTypeData(item) {
        item.create_time_str = new Date(item.create_time * 1000).format('Y-M-D hh:mm:ss');
        let content = JSON.parse(item.content);
        item.content = content;
        switch (item.type) {
          case 'order_new':
            // 新订单
            item.tip_arr = [{
              label: this.$ts('客户'),
              value: content.customer
            }, {
              label: this.$ts('单号'),
              value: content.order_no
            }, {
              label: this.$ts('金额'),
              value: content.money
            }];
            break;
          case 'order_convert':
            // 订单转化
            item.tip_arr = [{
              label: this.$ts('客户'),
              value: content.com_name
            }, {
              label: this.$ts('单号'),
              value: content.order_no
            }, {
              label: this.$ts('原因'),
              value: content.reason
            }];
            break;
          case 'sort_finish':
            // 分拣完成
            item.tip_arr = [{
              label: this.$ts('客户'),
              value: content.com_name
            }, {
              label: this.$ts('单号'),
              value: content.order_no
            }];
            break;
          case 'sort_loss':
            // 分拣缺货
            item.tip_arr = [{
              label: this.$ts('分拣'),
              value: content.sort_man
            }, {
              label: this.$ts('客户'),
              value: content.com_name
            }, {
              label: this.$ts('单号'),
              value: content.order_no
            }, {
              label: this.$ts('商品'),
              value: content.goods
            }, {
              label: this.$ts('缺货'),
              value: content.loss_num
            }];
            break;
          case 'basket_refund':
            // 退筐申请
            item.tip_arr = [{
              label: this.$ts('客户'),
              value: content.customer
            }, {
              label: this.$ts('周转筐'),
              value: content.basket
            }, {
              label: this.$ts('退还'),
              value: content.refund_num
            }];
            break;
          case 'goods_apply':
            // 商品审核
            item.tip_arr = [{
              label: this.$ts('商品'),
              value: content.goods
            }, {
              label: this.$ts('供应'),
              value: content.supplier
            }];
            break;
          case 'subcontract_loss':
            // 分包缺货
            item.tip_arr = [{
              label: this.$ts('分拣'),
              value: content.sort_man
            }, {
              label: this.$ts('商品'),
              value: content.goods
            }, {
              label: this.$ts('清单'),
              value: content.detail
            }];
            break;
          case 'expire_postpone':
            // 赠送时长
            item.tip_arr = [{
              label: this.$ts('天数'),
              value: content.postpone_day
            }, {
              label: this.$ts('消息'),
              value: content.satisfy_condition
            }];
            break;
          case 'receive_exception':
            // 收货异常
            item.tip_arr = [{
              label: this.$ts('客户'),
              value: content.customer
            }, {
              label: this.$ts('商品'),
              value: content.goods
            }, {
              label: this.$ts('下单'),
              value: content.buy_num
            }, {
              label: this.$ts('收货'),
              value: content.customer
            }];
            break;
          case 'goods_modify':
            // 修改商品
            item.tip_arr = [{
              label: this.$ts('修改'),
              value: content.user
            }, {
              label: this.$ts('商品'),
              value: content.goods
            }, {
              label: this.$ts('规格'),
              value: content.spec
            }, {
              label: this.$ts('数量'),
              value: `${content.old_spec_num} => ${content.new_spec_num}`
            }, {
              label: this.$ts('成本'),
              value: `${content.old_spec_cost} => ${content.new_spec_cost}`
            }, {
              label: this.$ts('售价'),
              value: `${content.old_spec_sell} => ${content.new_spec_sell}`
            }];
            break;
          case 'out_check':
            // 出库验收
            item.tip_arr = [{
              label: this.$ts('单号'),
              value: content.order_no
            }, {
              label: this.$ts('客户'),
              value: content.com_name
            }, {
              label: this.$ts('商品'),
              value: content.goods
            }, {
              label: this.$ts('下单'),
              value: content.buy_num
            }, {
              label: this.$ts('出库'),
              value: content.out_num
            }];
            break;
          case 'export':
            // 出库验收
            item.tip_arr = [{
              label: '',
              value: content.type
            }, {
              label: '',
              value: content.result
            }];
            break;
          default:
            item.tip_arr = [];
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  .pop {
    width: 300px;
    height: 400px;
    position: fixed;
    z-index: 110;
    bottom: 0;
    right: 0;
    background-color: #ffffff;
    border: 1px solid #cccccc;
    box-shadow: 2px 2px 10px #000;
  }

  .pop_more {
    width: 100%;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    color: #999;
    text-align: center;
    cursor: pointer;
  }

  .message_icon_box {
    display: flex;
    align-items: center;
    position: relative;
  }

  .customer_icon {
    position: absolute;
    bottom: -12px;
  }

  .pop_top {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: var(--theme-color);
    color: #ffffff;
  }

  .pop_top p {
    font-size: 16px;
    box-sizing: border-box;
    padding: 18px 20px 18px 100px;

  }

  .close {
    width: 30px;
    height: 30px;
    color: #000000;
    position: absolute;
    color: #ffffff;
    font-size: 30px;
    right: 10px;
    top: 10px;
    cursor: pointer;
  }

  .pop_content {
    height: 345px;
    width: 100%;
    overflow-y: auto;
  }

  .pop_content_li {
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    position: relative;
    border-bottom: 1px solid #cccccc;
    cursor: pointer;
  }

  .pop_content_li span {
    font-size: 12px;
  }

  .pop_content_li div {
    font-size: 14px;
    line-height: 20px;
  }

  .li_title {
    color: var(--theme-color);

    &.normal {
      color: #00A71C;
    }

    &.warn {
      color: #E6A23C;
    }

    &.danger {
      color: #FF0000;
    }
  }

  .li_content {
    color: #666666;
    font-size: 12px !important;
  }

  .btn {
    position: absolute;
    top: 12px;
    right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Navbar/MessageModal.vue